<div class="divider-wrapper">
  <div />
</div>

<style lang="scss">
  .divider-wrapper > div {
    border: 0.5px solid #d3d3d3;
  }
</style>
